import React, { Component } from 'react';
class BannerImg extends Component {

  render() {
    const { style } = this.props;
 
    return (<div style={style} >{this.props.children}</div>);
   }
}

export default BannerImg;

